export var CollectLogItemTypeEnum;
(function (CollectLogItemTypeEnum) {
    CollectLogItemTypeEnum[CollectLogItemTypeEnum["Customs"] = 20] = "Customs";
    CollectLogItemTypeEnum[CollectLogItemTypeEnum["GlobalSearch"] = 10] = "GlobalSearch";
})(CollectLogItemTypeEnum || (CollectLogItemTypeEnum = {}));
[];
